var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("h1", [
        _vm._v(
          " " +
            _vm._s(
              _vm.user.id != null
                ? _vm.$t("settings.users.userEdit")
                : _vm.$t("settings.users.userNew")
            ) +
            " "
        )
      ]),
      _c(
        "div",
        { staticClass: "mt-3 elevation-12 grey lighten-4" },
        [
          _c("user-settings-menu"),
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _vm.$store.getters["isWnbUser"]
                        ? _c(
                            "div",
                            {
                              staticClass: "elevation-12",
                              staticStyle: {
                                "text-align": "center",
                                display: "block",
                                background: "white",
                                "z-index": "1",
                                position: "absolute",
                                width: "300px",
                                left: "50%",
                                "margin-top": "50px",
                                "margin-left": "-150px",
                                padding: "50px"
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  alt: "Logo WNB",
                                  src: "/img/wnb-logo-vertical.png"
                                }
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("settings.users.settingsInWnb")
                                  ) +
                                  " "
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "primary",
                                  attrs: { block: "" },
                                  on: { click: _vm.redirectToWnb }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("settings.users.goToWnbButton")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-radio-group",
                        {
                          attrs: {
                            disabled: _vm.$store.getters["isWnbUser"],
                            mandatory: false,
                            row: ""
                          },
                          model: {
                            value: _vm.user.sex,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "sex", $$v)
                            },
                            expression: "user.sex"
                          }
                        },
                        [
                          _c("v-radio", {
                            attrs: { label: _vm.$t("global.mr"), value: 1 }
                          }),
                          _c("v-radio", {
                            attrs: { label: _vm.$t("global.ms"), value: 2 }
                          }),
                          _c("v-radio", {
                            attrs: { label: _vm.$t("global.notSet"), value: 0 }
                          })
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        attrs: {
                          disabled: _vm.$store.getters["isWnbUser"],
                          label:
                            _vm.$t(
                              "settings.users.basicData.fields.name.name"
                            ) + "*",
                          rules: _vm.user.nameRules
                        },
                        model: {
                          value: _vm.user.name,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "name", $$v)
                          },
                          expression: "user.name"
                        }
                      }),
                      !_vm.$store.getters["isAdmin"]
                        ? _c("v-text-field", {
                            attrs: {
                              disabled: _vm.$store.getters["isWnbUser"],
                              label: _vm.$t(
                                "settings.users.basicData.fields.middleName.name"
                              ),
                              placeholder: _vm.$t("global.optional")
                            },
                            model: {
                              value: _vm.user.middle_name,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "middle_name", $$v)
                              },
                              expression: "user.middle_name"
                            }
                          })
                        : _vm._e(),
                      _c("v-text-field", {
                        attrs: {
                          disabled: _vm.$store.getters["isWnbUser"],
                          label:
                            _vm.$t(
                              "settings.users.basicData.fields.surname.name"
                            ) + "*",
                          rules: _vm.user.surnameRules
                        },
                        model: {
                          value: _vm.user.surname,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "surname", $$v)
                          },
                          expression: "user.surname"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          label:
                            _vm.$t(
                              "settings.users.basicData.fields.login.name"
                            ) + "*",
                          rules: _vm.user.loginRules
                        },
                        model: {
                          value: _vm.user.login,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "login", $$v)
                          },
                          expression: "user.login"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          disabled: _vm.$store.getters["isWnbUser"],
                          label:
                            _vm.$t(
                              "settings.users.basicData.fields.email.name"
                            ) + "*",
                          rules: _vm.validators.emailRules
                        },
                        model: {
                          value: _vm.user.email,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "email", $$v)
                          },
                          expression: "user.email"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          disabled: _vm.$store.getters["isWnbUser"],
                          label:
                            _vm.$t(
                              "settings.users.basicData.fields.password.name"
                            ) + "*",
                          placeholder:
                            _vm.user.id != null
                              ? _vm.$t(
                                  "settings.users.basicData.fields.password.noChange"
                                )
                              : "",
                          rules: _vm.validators.passwordRules,
                          password: "",
                          type: "password"
                        },
                        model: {
                          value: _vm.user.password,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "password", $$v)
                          },
                          expression: "user.password"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          disabled: _vm.$store.getters["isWnbUser"],
                          label:
                            _vm.$t(
                              "settings.users.basicData.fields.repeatPassword.name"
                            ) + "*",
                          placeholder:
                            _vm.user.id != null
                              ? _vm.$t(
                                  "settings.users.fields.repeatPassword.noChange"
                                )
                              : "",
                          rules: _vm.validators.repeatPasswordRules,
                          password: "",
                          type: "password"
                        },
                        model: {
                          value: _vm.user.repeatPassword,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "repeatPassword", $$v)
                          },
                          expression: "user.repeatPassword"
                        }
                      }),
                      _c("date-time-picker-computed", {
                        attrs: {
                          "date-time-model": _vm.user.password_expire_at,
                          clearable: true,
                          placeholder: _vm.$t(
                            "settings.users.basicData.fields.passwordExpires.placeholder"
                          ),
                          label: _vm.$t(
                            "settings.users.basicData.fields.passwordExpires.name"
                          )
                        },
                        on: {
                          "update:dateTimeModel": function($event) {
                            return _vm.$set(
                              _vm.user,
                              "password_expire_at",
                              $event
                            )
                          },
                          "update:date-time-model": function($event) {
                            return _vm.$set(
                              _vm.user,
                              "password_expire_at",
                              $event
                            )
                          }
                        }
                      }),
                      _vm.$store.getters["userProperties"].system_settings
                        .is_module_travel_service_enabled === 2 ||
                      _vm.$store.getters["userProperties"].system_settings
                        .is_module_delegation_enabled === 2
                        ? [
                            _c("v-text-field", {
                              staticClass: "user-mobile-number",
                              attrs: {
                                disabled: _vm.$store.getters["isWnbUser"],
                                label: _vm.$t(
                                  "settings.users.basicData.fields.phone.name"
                                ),
                                placeholder: "+48 111-222-333",
                                rules: _vm.validators.phoneNumberRules,
                                mask: "+## ###-###-###",
                                required: ""
                              },
                              model: {
                                value: _vm.user.phone,
                                callback: function($$v) {
                                  _vm.$set(_vm.user, "phone", $$v)
                                },
                                expression: "user.phone"
                              }
                            }),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("date-picker", {
                                  attrs: {
                                    model: _vm.user.birth_date,
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.birthDate.name"
                                    ),
                                    clearable: true
                                  },
                                  on: {
                                    "update:model": function($event) {
                                      return _vm.$set(
                                        _vm.user,
                                        "birth_date",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-text-field", {
                                  attrs: {
                                    disabled: _vm.$store.getters["isWnbUser"],
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.documentNumber.name"
                                    ),
                                    placeholder: "ABC 123456"
                                  },
                                  model: {
                                    value: _vm.user.document_number,
                                    callback: function($$v) {
                                      _vm.$set(_vm.user, "document_number", $$v)
                                    },
                                    expression: "user.document_number"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("date-picker", {
                                  attrs: {
                                    disabled: _vm.$store.getters["isWnbUser"],
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.documentExpire.name"
                                    ),
                                    placeholder: "2020-01-01",
                                    model: _vm.user.document_expire,
                                    clearable: true
                                  },
                                  on: {
                                    "update:model": function($event) {
                                      return _vm.$set(
                                        _vm.user,
                                        "document_expire",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-text-field", {
                                  attrs: {
                                    disabled: _vm.$store.getters["isWnbUser"],
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.documentIssuePlace.name"
                                    ),
                                    placeholder: "Warszawa"
                                  },
                                  model: {
                                    value: _vm.user.document_issue_place,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.user,
                                        "document_issue_place",
                                        $$v
                                      )
                                    },
                                    expression: "user.document_issue_place"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-text-field", {
                                  attrs: {
                                    disabled: _vm.$store.getters["isWnbUser"],
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.nationality.name"
                                    ),
                                    placeholder: _vm.$t(
                                      "settings.users.basicData.fields.nationality.placeholder"
                                    )
                                  },
                                  model: {
                                    value: _vm.user.nationality,
                                    callback: function($$v) {
                                      _vm.$set(_vm.user, "nationality", $$v)
                                    },
                                    expression: "user.nationality"
                                  }
                                })
                              : _vm._e(),
                            !_vm.$store.getters["isAdmin"]
                              ? _c("v-checkbox", {
                                  attrs: {
                                    label: _vm.$t(
                                      "settings.users.basicData.fields.isNotifyNewTravelServiceResponse.name"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.user
                                        .is_notify_new_travel_service_response,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.user,
                                        "is_notify_new_travel_service_response",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "user.is_notify_new_travel_service_response"
                                  }
                                })
                              : _vm._e()
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card",
            [
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled:
                          !_vm.formValid || _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.save")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }